import firebase from "firebase/app";

import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";

var config = {
	apiKey: "AIzaSyBDeFgzLWcMlqRMUoveKzScar8raT7Hats",
	authDomain: "milagritoapp.firebaseapp.com",
	databaseURL: "https://milagritoapp.firebaseio.com",
	projectId: "milagritoapp",
	storageBucket: "milagritoapp.appspot.com",
	messagingSenderId: "531101699633",
};

export default !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();
